export default __webpack_public_path__ + "static/bunker-pages-1-mobile-d0b6e8b6ce0b39c912fecf7b8b2a04e0.jpg";